<template>
  <section class="footer-nav-strip" aria-label="栏目入口">
    <button
      v-for="item in front.secondaryNavItems"
      :key="item.id"
      type="button"
      @click="front.goPath(item.path)"
    >
      <span class="footer-nav-icon" aria-hidden="true">
        <!-- 学会沿革：时间轴 -->
        <svg v-if="item.icon === 'history'" viewBox="0 0 48 48" fill="none">
          <circle cx="12" cy="14" r="3.2" fill="currentColor"/>
          <circle cx="24" cy="24" r="3.2" fill="currentColor"/>
          <circle cx="36" cy="34" r="3.2" fill="currentColor"/>
          <path d="M12 17.5v13.5M24 14v6.5M24 27.5V34M36 17.5V30.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>
        </svg>
        <!-- 历史相册：相框 -->
        <svg v-else-if="item.icon === 'gallery'" viewBox="0 0 48 48" fill="none">
          <rect x="8" y="12" width="32" height="24" rx="2" stroke="currentColor" stroke-width="2.6"/>
          <path d="M8 32l8-8 6 6 7-9 11 11" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="17" cy="19" r="2.4" fill="currentColor"/>
        </svg>
        <!-- 会员公告：喇叭 -->
        <svg v-else-if="item.icon === 'announcements'" viewBox="0 0 48 48" fill="none">
          <path d="M10 20h6l12-8v24L16 28h-6V20z" fill="currentColor"/>
          <path d="M34 18c2.2 2 3.4 4.6 3.4 7.5S36.2 31 34 33" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>
          <path d="M38.5 14c3.2 3 5 6.8 5 11.5s-1.8 8.5-5 11.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>
        </svg>
        <!-- 通知要闻：报纸 -->
        <svg v-else-if="item.icon === 'news'" viewBox="0 0 48 48" fill="none">
          <rect x="9" y="10" width="30" height="28" rx="2" stroke="currentColor" stroke-width="2.6"/>
          <path d="M15 18h18M15 24h18M15 30h12" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/>
        </svg>
        <!-- 国际交流：地球 -->
        <svg v-else-if="item.icon === 'international'" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="14" stroke="currentColor" stroke-width="2.6"/>
          <ellipse cx="24" cy="24" rx="7" ry="14" stroke="currentColor" stroke-width="2.2"/>
          <path d="M10 24h28M13 17h22M13 31h22" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <!-- 规章条例：文档 -->
        <svg v-else-if="item.icon === 'regulations'" viewBox="0 0 48 48" fill="none">
          <path d="M14 8h14l8 8v24H14V8z" stroke="currentColor" stroke-width="2.6" stroke-linejoin="round"/>
          <path d="M28 8v8h8M18 24h12M18 30h12M18 36h8" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
        </svg>
        <!-- 公开文件：文件夹 -->
        <svg v-else viewBox="0 0 48 48" fill="none">
          <path d="M8 16h12l3 3h17v17H8V16z" stroke="currentColor" stroke-width="2.6" stroke-linejoin="round"/>
          <path d="M8 22h32" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
        </svg>
      </span>
      <strong>{{ item.label }}</strong>
    </button>
  </section>
</template>

<script>
export default {
  name: 'FooterNavStrip',
  inject: ['front']
}
</script>
